module.exports = __webpack_public_path__ + "img/icon_send.fd371675.svg";